export default {
    wager: "You need to win back the full amount of the deposit or the bonus you received in order for the balance to be available for withdrawal.",
    balances: {
        haveWager: (available, wager) => `There is an unfinished wagering of <b>$${wager}</b> on your account, so <b>$${available}</b> is available for withdrawal.`,
        full: `Your entire balance is available for withdrawal`
    },
    cashout_wager: wager => `There is an unfinished wagering of <b>$${wager}</b> on your account. When funds are withdrawn, these funds will be burned!`,
    testyourluck: (rules, roi_rate) => `You will be able to withdraw <b>$${rules.cashout}</b> when your balance reaches <b>$${rules.minimal_cashout} or more</b>. After the withdrawal, the funds will need to be wagered.`,
    freeplay: (rules, roi_rate) => `You will be able to withdraw <b>$${rules.cashout}</b> when your balance reaches <b>$${rules.minimal_cashout} or more</b>. After the withdrawal, the funds will need to be wagered.`,
    sessions: (sessions, roi_rate) => {
        const rules = sessions[roi_rate].filter(s => s.type === 'cash');

        let message = '<b>PLAY BIG - WIN BIG</b><br/><br/>';
        for(let i = 1; i < rules.length; i++)
            message += `$${rules[i].amounts.from} to $${Math.floor(rules[i].amounts.to)} → Max cashout <b>$${rules[i].maximal_cashout}</b> <br/>`;

        message += `<br/>We use a dynamic deposit wagering mode, depending on your playing style.<br/>Your wagering mode: <b>${roi_rate}</b>`;

        return message; 
    }
}